export default __webpack_public_path__ + "images/c9f590c45dc38d1848e7ff77fd9e66c6.svg";